module.exports = __webpack_public_path__ + "static/nozbe-a6f3e8963a5a07bc99dbfc5686dafce5.png";